/* tslint:disable */
/* eslint-disable */
import { GlobalEnumsAceXfoundportalobjekt as AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt } from '../../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface ICheckAnfrageDescriptionQuery {
  anfrageId?: string;
  ausschreibungId?: string;
  description?: null | string;
  scope?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
}
export class CheckAnfrageDescriptionQuery extends BaseModel implements ICheckAnfrageDescriptionQuery {
  anfrageId?: string;
  ausschreibungId?: string;
  description?: null | string;
  scope?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
}

